"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckTradePwdRequest = void 0;
var CheckTradePwdRequest = /** @class */ (function () {
    function CheckTradePwdRequest() {
    }
    return CheckTradePwdRequest;
}());
exports.CheckTradePwdRequest = CheckTradePwdRequest;
;
//# sourceMappingURL=checkTradePwd.request.js.map